// Abschluss-Feier — gleicher Event-Mechanismus wie TERMINE_CHANGED_EVENT in terminUtils.js.
// Ein Custom Event statt Prop-Drilling durch die Modals, da <Celebration/> einmal am
// App-Root sitzt und aus DetailModal/UnitPickerModal getriggert wird.
export const CELEBRATE_EVENT = 'crm:celebrate';

// Von DetailModal/UnitPickerModal nach einem frischen "Geclosed" aufgerufen.
// newCloses: Anzahl der in diesem Speichervorgang NEU geschlossenen Einheiten (meist 1) —
// beeinflusst nur die Vibrationsstärke.
export function celebrateClose(newCloses = 1) {
  window.dispatchEvent(new CustomEvent(CELEBRATE_EVENT));
  // Haptisches Feedback fürs Handy an der Haustür — no-op auf Desktop/iOS Safari ohne Support.
  try { navigator.vibrate?.(newCloses > 1 ? [40, 60, 40, 60, 90] : [40, 60, 90]); } catch {}
}
